<template>
<div>
  <table
    v-if="item.invoicePositions.length > 0"
    class="table table-responsive-md table-sm table-hover not-border-table">
    <thead class="text-center">
    <tr>
      <th class="w-2">
        {{ $t('views.exsbinvoices.form.invoicePositionHeaders.lp') }}
      </th>
      <th class="w-2">
        <i class="fas fa-percent"></i>
      </th>
      <th>
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}
      </th>
      <th>
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.measure')}}
      </th>
      <th class="w-5">
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.quantity')}}
      </th>
      <th>
        {{ $t('views.exsbinvoices.form.pkwiu') }}
      </th>
      <th>
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.priceNettoPerUnit')}}
      </th>
      <th>
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}
      </th>
      <th class="w-5">
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}
      </th>
      <th class="w-5">
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}
      </th>
      <th>
        {{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}
      </th>
      <th>
        {{ $t('views.exsbinvoices.form.gtu') }}
      </th>
      <th></th>
      <th></th>
    </tr>
    </thead>
    <tbody v-for="(position, positionIndex) in item.invoicePositions" :key="'position_'+positionIndex">
    <tr>
      <td>
        <span class="h6">{{ positionIndex + 1 }}</span>
      </td>
      <td>
        <b-form-checkbox @input="$forceUpdate()" v-model="position.hasDiscount" :id="'hasDisount_' + positionIndex" />
      </td>
      <td>
        <input v-if="position.isCustom" :id="'item_' + positionIndex" type="text" v-model="position.customItem" class="form-control">
        <model-select v-else :id="'item_' + positionIndex" :options="itemOptions" v-model="position.item" @input="selectItemHandler(positionIndex)"></model-select>
      </td>
      <td>
        <model-select :id="'measure_' + positionIndex" :isDisabled="!position.isCustom" :options="measureOptions" v-model="position.measure" @input="positionHandler(positionIndex)" ></model-select>
      </td>
      <td>
        <input class="form-control" :id="'quantity_' + positionIndex" type="text" v-model.number="position.quantity" @input="positionHandler(positionIndex)">
      </td>
      <td>
        <input class="form-control" :id="'pkwiu_' + positionIndex" type="text" v-model="position.pkwiu">
      </td>
      <td>
        <input class="form-control" :id="'priceNettoPerUnit_' + positionIndex" type="text" v-model.number="position.priceNettoPerUnit" :disabled="!position.isCustom" @input="positionHandler(positionIndex)">
      </td>
      <td>
        <input class="form-control" :id="'valueNetto_' + positionIndex" type="text" v-model.number="position.valueNetto" disabled>
      </td>
      <td>
        <model-select :id="'vatRate_' + positionIndex" :isDisabled="!position.isCustom" :options="vatRateOptions" v-model="position.vatRate" @input="positionHandler(positionIndex)"></model-select>
      </td>
      <td>
        <input class="form-control" :id="'vatAmount_' + positionIndex" type="text" v-model.number="position.vatAmount" disabled>
      </td>
      <td>
        <input class="form-control" :id="'valueBrutto_' + positionIndex" type="text" v-model.number="position.valueBrutto" disabled>
      </td>
      <td>
        <model-select v-model="position.gtu" :options="gtuOptions" :placeholder="$t('views.exsbinvoices.form.gtu')" name="gtu" id="item.gtu"></model-select>
      </td>
      <td>
        <button type="button" class="btn btn-link fa fa-trash fa-lg" @click="removeItem(positionIndex)"></button>
      </td>
      <td>
        <b-button
          class="btn btn-link fa fa-bars fa-lg"
          v-b-modal.modal-no-backdrop
          :disabled="!position.item"
          @click="showModal(item['@id'])"
          v-b-tooltip.hover :title="$t('views.exsbinvoices.list.priceUserDataList')"
        ></b-button>
        <b-modal ref="my-modal" hide-footer
          id="modal-no-backdrop"
          size="lg"
         >
        <div slot="modal-header" class="w-100">
          <h6 class="modal-title m-0 float-left">
            {{$t('views.exsbinvoices.list.priceUserDataList')}}
          </h6>
          <button type="button" aria-label="Close" class="close" @click="hideModal()">
            ×
          </button>
        </div>
          <div class="text-center" v-if="item.firm">
            <table class="table table-sm table-striped table-hover text-center">
              <thead>
                <tr>
                  <td>{{$t('views.exsbinvoices.list.contactor')}}</td>
                  <td>{{$t('views.exsbinvoices.list.priceBrutto')}}</td>
                  <td>{{$t('views.exsbinvoices.list.priceNetto')}}</td>
                  <td>{{$t('views.exsbinvoices.list.promotion')}}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in priceUserDataOptions" :key="item['@id']">
                  <td v-if="item.firmname1">{{item.firmname1}}</td>
                  <td v-if="!item.firmname1 && item.fullName">{{item.fullName}}</td>
                  <td>{{item.priceBrutto}} zł</td>
                  <td>{{item.priceNetto}} zł</td>
                  <td>{{item.promotionTitle}}</td>
                  <td>
                    <b-button
                      class="btn btn-link fa fa-copy fa-lg"
                      v-b-tooltip.hover :title="$t('views.exsbinvoices.form.copyPrice')"
                    ></b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <br>
            <div>
              <button type="button" class="btn btn-sm" v-b-toggle.collapse-1>
                <i class="mr-1 fa fa-plus"></i>
                {{$t('views.exsbpriceuserdata.form.addPriceUserData')}}
              </button>
              <!-- Element to collapse -->
              <b-collapse id="collapse-1">
                <br>
                <form @submit.prevent="submit(item, positionIndex)">
                  <b-row>
                    <b-col sm="12" md="3">
                      <b-form-group>
                        <label for="userdata_input">{{ $t('views.exsbpaymentsmade.list.contractor') }}</label>
                        <input :placeholder="$t('views.exsbitems.form.priceBrutto')" v-model="item.firm" type="text" class="form-control" id="userdata_input">
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                      <b-form-group>
                        <label for="price_brutto">{{ $t('views.exsbitems.form.priceBrutto') }}:</label>
                        <input :placeholder="$t('views.exsbitems.form.priceBrutto')" v-model="item.priceBrutto" type="text" class="form-control" id="price_brutto">
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                      <b-form-group>
                        <label for="price_brutto">{{ $t('views.exsbitems.form.priceNetto') }}:</label>
                        <input :placeholder="$t('views.exsbitems.form.priceNetto')" v-model="item.priceNetto" type="text" class="form-control" id="price_netto">
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                      <b-form-group>
                        <label for="promotion_input">{{ $t('views.exsbpaymentsmade.list.promotion') }}</label>
                        <model-select id="promotion_input" :options="promotionOptions" v-model="item.idPromotion"></model-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <button type="submit" class="btn btn-primary float-left">{{ $t('buttons.submit') }}</button>
                    </b-col>
                  </b-row>
                </form>
              </b-collapse>
            </div>
          </div>
          <h2 class="text-center" v-if="!item.firm">{{$t('views.exsbinvoices.list.notSelectedCompany')}}</h2>
        </b-modal>
      </td>
<!--RABAT-->
    </tr>
    <tr v-if="position.hasDiscount" >
      <td colspan="2"></td>
      <td>
        <span class="h6">{{$t('views.exsbinvoices.form.discount')}}</span>
      </td>
      <td>
        <input class="form-control" :id="'discount_' + positionIndex" type="text" v-model="position.discount" @input="positionHandler(positionIndex)">
      </td>
      <td colspan="2">
        <span class="h6">{{$t('views.exsbinvoices.form.discountDescription')}}</span>
      </td>
      <td colspan="5">
        <input class="form-control" :id="'discount_description_' + positionIndex" type="text" v-model="position.discountDescription" @input="positionHandler(positionIndex)">
      </td>
    </tr>
    </tbody>
    <tbody>
    <tr>
      <td colspan="6">
      </td>
      <td colspan="3">
        <span class="h6">
          {{ $t('views.exsbinvoices.form.vatSum') }}
        </span>
      </td>
      <td colspan="4"></td>
    </tr>
    <!--SUMY-->
    <tr>
      <td colspan="6"></td>
      <td>
        <span class="h6">{{ $t('views.exsbinvoices.form.total') }}</span>
      </td>
      <td>
        <input class="form-control" id="totalValueNetto" type="text" disabled v-model="item.totalValueNetto">
      </td>
      <td></td>
      <td>
        <input class="form-control" id="totalVatAmount" type="text" disabled v-model="item.totalVatAmount">
      </td>
      <td>
        <input class="form-control" id="totalValueBrutto" type="text" disabled v-model="item.totalValueBrutto">
      </td>
      <td colspan="5"></td>
    </tr>
    <!--ZESTAWIENIE VAT-->
    <tr v-for="(totalSumArray, id) in item.totalSums" v-bind:key="'totalSumArray-' + id">
      <td colspan="7" v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0"></td>
      <td v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0">
        <div class="form-group">
          <input v-model="totalSumArray.totalValueNetto" class="form-control text-right" disabled type="text">
        </div>
      </td>
      <td v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0">
        <div class="form-group">
          <input v-model="totalSumArray.vatRange" class="form-control text-right" disabled type="text">
        </div>
      </td>
      <td v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0">
        <div class="form-group">
          <input v-model="totalSumArray.totalVatAmount" class="form-control text-right" disabled type="text">
        </div>
      </td>
      <td v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0">
        <div class="form-group">
          <input v-model="totalSumArray.totalValueBrutto" class="form-control text-right" disabled type="text">
        </div>
      </td>
      <td v-if="totalSumArray.totalValueNetto !== 0 && totalSumArray.totalValueBrutto !== 0" colspan="5"></td>
    </tr>
    <tr>
      <td colspan="8"></td>
      <td colspan="2">
        <span class="h6">{{ $t('views.exsbinvoices.form.toPay') }}</span>
      </td>
      <td>
        <input class="form-control" id="totalValueBrutto" type="text" disabled v-model="item.totalValueBrutto">
      </td>
      <td colspan="5"></td>
    </tr>
    </tbody>
  </table>
  <b-row>
    <b-col>
      <button type="button" class="btn btn-primary" @click="addPosition()">
        {{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}
      </button>
      <button type="button" class="btn btn-warning" @click="addPosition(true)"> {{ $t('buttons.addCustomPosition') }} </button>
    </b-col>
  </b-row>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import TotalSumsMixin from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/TotalSumsMixin'

export default {
  name: 'InvoicePositions',

  props: ['item'],
  mixins: [TotalSumsMixin],

  data () {
    return {
      gtuOptions: [
        { value: 'GTU_01', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_01') },
        { value: 'GTU_02', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_02') },
        { value: 'GTU_03', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_03') },
        { value: 'GTU_04', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_04') },
        { value: 'GTU_05', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_05') },
        { value: 'GTU_16', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_06') },
        { value: 'GTU_17', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_07') },
        { value: 'GTU_18', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_08') },
        { value: 'GTU_19', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_09') },
        { value: 'GTU_10', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_10') },
        { value: 'GTU_11', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_11') },
        { value: 'GTU_12', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_12') },
        { value: 'GTU_13', text: this.$t('views.exsbinvoices.form.gtuOptions.GTU_13') }
      ]
    }
  },

  components: {
    ModelSelect
  },

  watch: {
    'item.invoicePositions': {
      deep: true,
      handler () {
        this.totalHandler()
        this.calculateTotalSums()
      }
    },
    'item.invoicePositions.vatRate': function (val) {
      this.submit(val)
    },
    'item.firm': function (val) {
      this.fetchPriceUserDataOptions(val)
    }
  },

  computed: {
    ...mapGetters({
      items: 'exsbitem/list/items',
      vatRates: 'exsbinvoice/list/vatRateOptions',
      measures: 'exsbinvoice/list/measureOptions',
      priceUserDataRawOptions: 'exsbinvoice/list/promotionOptions',
      promotionRawOptions: 'exsbpriceuserdata/list/promotionOptions'
    }),
    itemOptions () {
      return this.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name
        }
      })
    },
    vatRateOptions () {
      return this.vatRates.map(entry => {
        return {
          value: entry['@id'],
          text: entry.range
        }
      })
    },
    measureOptions () {
      return this.measures.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name
        }
      })
    },
    priceUserDataOptions () {
      return this.priceUserDataRawOptions.map(entry => {
        return {
          value: entry['@id'],
          priceBrutto: entry.priceBrutto,
          priceNetto: entry.priceNetto,
          promotionTitle: entry.idPromotion.title,
          firmname1: entry.idUserData.firmname1,
          fullName: entry.idUserData.fullName,
          idUserData: entry.idUserData['@id']
        }
      })
    },
    promotionOptions () {
      return this.promotionRawOptions.map(entry => {
        return {
          value: entry.value,
          text: entry.text
        }
      })
    }
  },

  created () {
    this.fetchItems()
    this.fetchVatRates()
    this.fetchMeasures()
    this.fetchPriceUserDataOptions()
    this.fetchPromotionOptions()
  },

  methods: {
    totalHandler () {
      this.item.totalValueNetto = 0
      this.item.totalValueBrutto = 0
      this.item.totalVatAmount = 0
      this.item.invoicePositions.forEach(position => {
        this.item.totalValueNetto = this.fixFraction(parseFloat(this.item.totalValueNetto) + position.valueNetto)
        this.item.totalValueBrutto = this.fixFraction(parseFloat(this.item.totalValueBrutto) + position.valueBrutto)
        this.item.totalVatAmount = this.fixFraction(parseFloat(this.item.totalVatAmount) + position.vatAmount)
      })
    },

    positionHandler (index) {
      let position = this.item.invoicePositions[index]
      let baseNetto = position.priceNettoPerUnit - position.discount
      let vat = position.vatRate ? this.getVatRate(position.vatRate).value : 0

      position.valueNetto = this.fixFraction(baseNetto * position.quantity)

      position.priceBruttoPerUnit = baseNetto + (baseNetto * (vat / 100))
      position.valueNetto = this.fixFraction(baseNetto * position.quantity)
      position.valueBrutto = this.fixFraction(position.priceBruttoPerUnit * position.quantity)
      position.vatAmount = this.fixFraction(baseNetto * (vat / 100) * position.quantity)
    },

    selectItemHandler (index) {
      let item = this.getItem(this.item.invoicePositions[index].item)
      let position = this.item.invoicePositions[index]
      let vat = this.getVatRate(item.vatRate['@id']).value
      position.priceNettoPerUnit = item.priceNetto
      position.priceBruttoPerUnit = item.priceBrutto
      position.measure = item.measure['@id']
      position.valueNetto = item.priceNetto
      position.valueBrutto = item.priceBrutto
      position.vatAmount = this.fixFraction((item.priceBrutto * vat) / (100 + vat))
      position.vatRate = item.vatRate['@id']
    },

    getItem (id) {
      return this.items.find(item => item['@id'] === id)
    },

    fixFraction (value) {
      if (typeof value !== 'number') {
        value = parseFloat(value)
      }
      return value.toFixed(2)
    },

    getVatRate (id) {
      return this.vatRates.find(vatRate => vatRate['@id'] === id)
    },

    removeItem (index) {
      this.item.invoicePositions.splice(index, 1)
    },

    hideModal () {
    },
    showModal () {
    },

    submit (item, positionIndex) {
      let data = Object.assign({}, this.data)
      data.priceBrutto = this.item.priceBrutto
      data.priceNetto = this.item.priceNetto
      data.idUserData = this.item.firm
      data.idPromotion = this.item.idPromotion
      data.idItem = item.invoicePositions[positionIndex].item
      data.idVatRate = item.invoicePositions[positionIndex].vatRate
      this.createPriceUserData(data)
    },
    ...mapActions({
      fetchItems: 'exsbitem/list/getItems',
      fetchVatRates: 'exsbinvoice/list/fetchVatRateOptions',
      fetchMeasures: 'exsbinvoice/list/fetchMeasureOptions',
      fetchPriceUserDataOptions: 'exsbinvoice/list/fetchPromotions',
      fetchPromotionOptions: 'exsbpriceuserdata/list/fetchPromotions',
      createPriceUserData: 'exsbpriceuserdata/create/create'
    }),

    addPosition (isCustom = false) {
      if (!isCustom) {
        this.item.invoicePositions.push({
          item: '',
          hasDiscount: false,
          discount: 0,
          discountDescription: '',
          isCustom: isCustom,
          priceNettoPerUnit: 0,
          priceBruttoPerUnit: 0,
          valueNetto: 0,
          valueBrutto: 0,
          quantity: 1,
          vatAmount: 0,
          vatRate: 0,
          gtu: '',
          pkwiu: ''
        })
      } else {
        this.item.invoicePositions.push({
          customItem: '',
          hasDiscount: false,
          discount: 0,
          discountDescription: '',
          isCustom: isCustom,
          priceNettoPerUnit: 0,
          priceBruttoPerUnit: 0,
          valueNetto: 0,
          valueBrutto: 0,
          quantity: 1,
          vatAmount: 0,
          vatRate: 0,
          gtu: '',
          pkwiu: ''
        })
      }
    }
  }
}
</script>

<style scoped>
.w-2 {
  width: 2%
}
.w-5 {
  width: 5%
}
</style>
